var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pack-lead-widget-table',{attrs:{"list":_vm.list,"packId":_vm.packId}})
}
var staticRenderFns = []

export { render, staticRenderFns }